// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20bKm","productName":"Table_productName__2nIL2"};